module.exports = __webpack_public_path__ + "media/images/nayya-claims-4ca3d3e0.svg";